export const SVC_COLS = [
  { key: "name", label: "Hizmet", type: "text" },
  { key: "unit", label: "Birim" },
  { key: "locs", label: "Geçerli Lokasyonlar", value: (s) => ((s.location_ids || []).length > 0 ? `${s.location_ids.length} lokasyon` : "Tümü") },
  { key: "status", label: "Durum" },
];
export const unitOptions = [
  { value: "m²", label: "m²" }, { value: "adet", label: "adet" }, { value: "kişi", label: "kişi" },
  { value: "saat", label: "saat" }, { value: "m³", label: "m³" }, { value: "mt", label: "mt" }, { value: "ton", label: "ton" },
];
export const statusOptions = [{ value: "Aktif", label: "Aktif" }, { value: "Pasif", label: "Pasif" }];
// hesap esası: Kişi Bazlı (puantaj günü × birim fiyat) ya da Aylık (birim fiyat ÷ 30 × puantaj günü) — kalemde boşsa üst hizmetinki geçerli
export const basisOptions = [{ value: "gunluk", label: "Kişi Bazlı" }, { value: "aylik", label: "Aylık" }];
export const basisLabel = (v) => basisOptions.find((o) => o.value === v)?.label || "";
export const emptySvc = { category_id: "", parent_id: null, billing_basis: "", name: "", unit: "m²", location_ids: [], scope: "global", project_ids: [], status: "Aktif" };
export const emptyCat = () => ({ name: "", status: "Aktif" });
// proje seçiliyse kapsam 'projects' (yalnız o projelerde görünür), seçili değilse 'global' (tüm projeler)
export const svcPayload = (f) => ({ ...f, parent_id: f.parent_id || null, billing_basis: f.billing_basis || null, project_ids: f.project_ids || [], scope: (f.project_ids || []).length ? "projects" : "global" });
// hizmet ağacı: üst hizmetler + altlarındaki kalemler (parent_id)
export const svcTree = (rows) => rows.filter((s) => !s.parent_id).map((p) => ({ ...p, kalems: rows.filter((k) => k.parent_id === p.id) }));
// sabit üst hizmetler (ASIL / GEÇİCİ PERSONEL HAKEDİŞİ): silinemez, adı değişmez — hakediş hesabı kalemlerine bağlı
const trKey = (s) => String(s || "").replace(/[İıŞşĞğÜüÖöÇç]/g, (c) => "IISSGGUUOOCC"["İıŞşĞğÜüÖöÇç".indexOf(c)]).toUpperCase().replace(/[^A-Z0-9]/g, "");
export const isProtectedSvc = (s) => !!s && !s.parent_id && ["ASILPERSONELHAKEDISI", "GECICIPERSONELHAKEDISI"].includes(trKey(s.name));
export const cls = "w-full px-3 py-2 text-sm border border-slate-300 rounded-md bg-white focus:border-amber-500 focus:ring-1 focus:ring-amber-500 outline-none";

export function L({ label, children }) {
  return (
    <div className="space-y-1.5">
      <label className="text-[10px] font-semibold uppercase tracking-wider text-slate-500">{label}</label>
      {children}
    </div>
  );
}

// Kişi Bazlı / Aylık rozeti; kalemde üstten miras alınmışsa soluk
export function BasisBadge({ basis, inherited = false, testid }) {
  if (!basis) return null;
  return (
    <span data-testid={testid} title={inherited ? "Hesap esası üst hizmetten" : "Hesap esası"}
      className={`ml-1.5 px-1.5 py-0.5 rounded text-[9px] font-bold uppercase ${basis === "aylik" ? "bg-violet-100 text-violet-700" : "bg-sky-100 text-sky-700"} ${inherited ? "opacity-60" : ""}`}>
      {basisLabel(basis)}
    </span>
  );
}

export function BasisSelect({ value, onChange, parentBasis, testid, className = cls }) {
  return (
    <select value={value || ""} onChange={(e) => onChange(e.target.value)} data-testid={testid} className={className}>
      <option value="">{parentBasis !== undefined ? `Hizmetle aynı${parentBasis ? ` (${basisLabel(parentBasis)})` : ""}` : "Seçilmedi"}</option>
      {basisOptions.map((o) => <option key={o.value} value={o.value}>{o.label}</option>)}
    </select>
  );
}
